// extracted by mini-css-extract-plugin
export default {"dialog":"help-modal_dialog__38o43","content":"help-modal_content__PGDnV","closeButton":"help-modal_closeButton__1nUzI"};